import { TrackerAchievements } from "UIPalette/TrackerAchievements/TrackerAchievements";
import { TrackerFourWeekPlans } from "UIPalette/TrackerFourWeekPlans/TrackerFourWeekPlans";
import { TrackerLearningMaterials } from "UIPalette/TrackerLearningMaterials/TrackerLearningMaterials";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { PropsWithChildren } from "react";
import { SyncTrackerDataButton } from "./SyncTrackerDataButton";
import { useTrackerDataSync } from "core/hooks/useTrackerDataSync";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { Column, Row } from "shared/UI/LayoutComponents/LayoutComponents";
import { useContentContext } from "core/state/ContentContext/ContentContext";
import { trackerToContentIdentifierMap } from "core/state/Trackers/TrackerMapping";

export type TrackerProps = {
  trackerType: TrackerType;
  heading: string;
} & PropsWithChildren;

export const Tracker = ({ trackerType, heading, children }: TrackerProps) => {
  const { getFourWeekPlanIds, getLearningMaterialCategoryIds } = useContentContext();
  const { requiresHealthPermission, loading } = useTrackerDataSync(trackerType);

  return (
    <>
      <PageHeader title={heading} hideForMobile />
      <Row>
        <Column>
          {children}
          {!loading && requiresHealthPermission && <SyncTrackerDataButton trackerType={trackerType} />}
          <TrackerAchievements trackerType={trackerType} />
        </Column>
        <Column>
          <TrackerFourWeekPlans planIdsFilter={getFourWeekPlanIds(trackerToContentIdentifierMap[trackerType])} />
          <TrackerLearningMaterials categoryIdsFilter={getLearningMaterialCategoryIds(trackerToContentIdentifierMap[trackerType])} />
        </Column>
      </Row>
    </>
  );
};
